var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.myClasses,style:(_vm.styles),attrs:{"href":_vm.url}},[(_vm.hasAccess && _vm.hasAccessText)?_c('span',[_vm._v(_vm._s(_vm.hasAccessText))]):_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }